import { useCheckAccountTraits } from '@cmg/auth';
import axios from 'axios';
import { useEffect, useState } from 'react';

import { CalendarCategory } from '../../../types/domain/calendar/constants';

export type RelevanceDetermination = {
  [offeringId: string]: {
    isRelevant: boolean;
    relevanceReason: string;
  };
};

export const useRelevanceDetermination = (
  offeringIds: string[],
  interestSummary: string,
  token: string | null,
  calendarCategory: CalendarCategory
) => {
  const [relevanceDetermination, setRelevanceDetermination] =
    useState<RelevanceDetermination | null>(null);
  const hasAIPermissions = useCheckAccountTraits(['PREMIUM_AI']);
  const isLiveCalendar = calendarCategory === CalendarCategory.LIVE;

  useEffect(() => {
    if (!hasAIPermissions || !interestSummary || !isLiveCalendar) {
      return;
    }

    axios
      .post(
        '/dlgw/api/v1/compat/datalabs/determine_relevance',
        {
          offeringIds,
          interestSummary,
        },
        {
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        }
      )
      .then(response => {
        setRelevanceDetermination(response.data);
      })
      .catch(error => {
        console.error('Error determining relevance:', error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offeringIds.length, interestSummary, token, hasAIPermissions, isLiveCalendar]);

  return { relevanceDetermination };
};
